<template>
  <div class="text-gray-800 pb-2.5">
    <div
      class="flex items-center"
      :class="desktop ? 'gap-x-2.5' : 'gap-x-[11px]'"
    >
      <span class="relative h-[30px] w-[39px] shrink-0" aria-hidden="true">
        <img
          :src="BasicMembership"
          alt=""
          class="absolute top-0 left-0 h-5 w-auto max-w-none rounded-[2px]"
        />
        <img
          :src="MembershipCard"
          alt=""
          class="absolute top-2.5 left-2.5 h-5 w-auto max-w-none rounded-[2px]"
        />
      </span>
      <span
        class="font-medium"
        :class="
          desktop ? 'text-[17px] leading-[24px]' : 'text-[22px] leading-[26px]'
        "
      >
        Dacr Basic and Pro Membership
      </span>
    </div>
    <p class="text-[15px] leading-[22px] mt-1.5">
      The copyright system for working creators.
    </p>

    <div
      class="h-px bg-[#efefef]"
      :class="desktop ? 'mt-[18px] mb-5' : 'my-5'"
    />

    <div class="space-y-[9px]">
      <div class="text-[15px] font-medium leading-[18px]">
        Included with copyright registration
      </div>
      <div
        v-for="item in registrationBenefits"
        :key="item"
        class="flex items-start gap-x-3"
      >
        <span class="flex h-[18px] shrink-0 items-center">
          <CheckmarkIcon class="size-[13px]" aria-hidden="true" />
        </span>
        <span class="text-[15px] leading-[18px]">{{ item }}</span>
      </div>
      <div class="flex items-start gap-x-3">
        <span class="flex h-[18px] shrink-0 items-center">
          <CheckmarkIcon class="size-[13px]" aria-hidden="true" />
        </span>
        <span class="text-[15px] leading-[18px]">
          <span
            class="bg-linear-to-r from-yellow-500 via-[#F84600] to-[#CE489A] font-medium text-transparent"
            style="-webkit-background-clip: text; background-clip: text"
          >
            Dacr AI
          </span>
          infringement detection and DIIS reports
        </span>
      </div>
    </div>

    <div class="mt-[19px] space-y-[9px]">
      <div class="text-[15px] font-medium leading-[18px]">
        Included with Dacr Membership
      </div>
      <div class="flex items-start gap-x-3">
        <span class="flex h-[18px] shrink-0 items-center">
          <CheckmarkIcon class="size-[13px]" aria-hidden="true" />
        </span>
        <span class="text-[15px] leading-[18px]">
          Membership in the global community of protected creators
        </span>
      </div>
      <div class="flex items-start gap-x-3">
        <span class="flex h-[18px] shrink-0 items-center">
          <CheckmarkIcon class="size-[13px]" aria-hidden="true" />
        </span>
        <span class="text-[15px] leading-[18px]">Dacr Membership card</span>
      </div>
      <div class="flex items-start gap-x-3">
        <span class="flex h-[18px] shrink-0 items-center">
          <CheckmarkIcon class="size-[13px]" aria-hidden="true" />
        </span>
        <div>
          <div class="text-[15px] leading-[18px]">
            Member-only events and benefits (Pro only)
          </div>
          <div class="mt-0.5 text-[13px] leading-[20px] text-gray-500">
            Workshops, creator events, discounts, and early access
          </div>
        </div>
      </div>
      <div
        v-for="item in membershipBenefits"
        :key="item"
        class="flex items-start gap-x-3"
      >
        <span class="flex h-[18px] shrink-0 items-center">
          <CheckmarkIcon class="size-[13px]" aria-hidden="true" />
        </span>
        <span class="text-[15px] leading-[18px]">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckmarkIcon } from '@dacr/icons'

import BasicMembership from '@/assets/images/BasicMembership.png'
import MembershipCard from '@/assets/images/MembershipCard.png'

defineProps<{ desktop?: boolean }>()

const registrationBenefits = [
  'Official registration with court-ready Certificate',
  'Register your work in partner countries for official national recognition under local law',
  'Recognized worldwide under Berne and TRIPS',
]

const membershipBenefits = [
  'Co-owners and authors on every registration',
  'Register on behalf of others',
  'Direct member support',
]
</script>
